<template>
    <div>
    <table class="open-positions">
        <tr class="open-positions__title-row">
            <td v-for="(title, index) in titles" :key="index"
              :class="title.class">
              {{title.title}}
            <!-- TODO: editable (clickable) icons -->
            </td>
        </tr>
        <tr class="open-positions__row"  v-for = "(item,index) in getPositions" :key="index + '_pos'">
            <td class="open-positions__row-item-number">{{item.id}}</td>
            <td class="open-positions__row-item-instrument">{{item.symbol}}</td>
            <td class="open-positions__row-item-time">{{item.timeEnter}}</td>
            <td class="open-positions__row-item-time">{{item.timeExit}}</td>
            <td class="open-positions__row-item-type"
                :class = "(item.side < 0) ? 'color-red' : 'color-green'">{{(item.side  === -1) ? 'SELL' : 'BUY'}}</td>
            <td class="open-positions__row-item-volume">{{item.volume}}</td>
            <td class="open-positions__row-item-price">{{item.priceEnter}}</td>
            <td class="open-positions__row-item-price">{{item.curPrice}}</td>
            <td class="open-positions__row-item-tp">{{item.tp}}</td>
            <td class="open-positions__row-item-sl">{{item.sl.toFixed(2)}}</td>
            <td class="open-positions__row-item-pl-s"
                :class = "(item.resultDepo < 0) ? 'color-red' : 'color-green'">{{item.resultDepo}}</td>
            <td class="open-positions__row-item-pl-pip"
                :class = "(item.resultPoint < 0) ? 'color-red' : 'color-green'">{{item.resultPoint}}</td>
        </tr>
    </table>
    <com-pager :page="page" :pagelen="pagelen" :total="total"
					@navigate="onNavigate"></com-pager>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ComPager from '../../ui-components/ui-pager'
export default {
    components : {
        "com-pager":ComPager
    },
data() {
    return {
        titles: [
                { title: 'Номер', class: 'open-positions__title-row-item-number', field: 'id' },
                { title: 'Инструмент', class: 'open-positions__title-row-item-instrument', field: 'symbol', order: 'asc'},
                { title: 'Время открытия', class: 'open-positions__title-row-item-time', field: 'timeEnter', order: 'asc'},
                { title: 'Время закрытия', class: 'open-positions__title-row-item-time', field: 'timeExit', order: 'asc'},
                { title: 'Тип', class: 'open-positions__title-row-item-type', field: 'side'},
                { title: 'Объём', class: 'open-positions__title-row-item-volume', field: 'volume'},
                { title: 'Цена отк.', class: 'open-positions__title-row-item-price', field: 'priceEnter'},
                { title: 'Цена закр.', class: 'open-positions__title-row-item-price', field: 'priceEnter'},
                { title: 'T/P', class: 'open-positions__title-row-item-tp', field: 'tp' },
                { title: 'S/L', class: 'open-positions__title-row-item-tp', field: 'sl' },
                { title: 'P/L, $', class: 'open-positions__title-row-item-pl-s', field: 'presultDepo' },
                { title: 'P/L, P', class: 'open-positions__title-row-item-pl-pip', field: 'resultPoint' },
            ],
        query: {
            pageLength: 50,
            page:0,
            symbol: ''
        }
    }
},
computed : {
    ...mapGetters ({
        getPositions: 'closPositions/getPositions',
        page: 'closPositions/getPage',
		total: 'closPositions/getTotal',
		pagelen: 'closPositions/getPageLength',
    }),
},
methods: {
    onPositions() {
        this.positions = this.getPositions
    },
    onNavigate(actions) {
        switch (actions) {
            case 'forward':
                this.query.page++;
                break;
            case 'backward':
                this.query.page--; 
                break;
            case 'begin': 
                this.query.page = 0;
                break;
            case 'end':
                this.query.page = Math.ceil(this.total / this.pagelen) - 1;
                break;
        }
        this.$store.dispatch("closPositions/readPositionsFromServer", this.query)
    },

},
created () {
    let query = { pageLength: 50, page: 0, symbol: '' }
    this.$store.dispatch("closPositions/readPositionsFromServer", query)
}   
}
</script>
<style lang="less" scoped>
.open-positions {
  background-color: #3d536b;
  border-radius: 4px 4px 0px 0px;
  width: 100%;

  &__title-row {
    border-bottom: solid 1px #374b62;
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 4;
    letter-spacing: 0.4px;
    color: #aabed2;
    text-transform: uppercase;
    text-align: left;

    &-item {
    }

    &-item-number {
      padding-left: 12px;
      width: 46px;
    }

    &-item-instrument {
      width: 73px;
      margin: 0px 4px;
    }

    &-item-time {
      width: 142px;
      margin: 0px 4px;
    }

    &-item-type {
      width: 40px;
      margin: 0px 4px;
    }

    &-item-volume {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-price {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-tp {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-sl {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-s {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-per {
      width: 35px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-pip {
      width: 35px;
      text-align: right;
      padding-right: 12px;
    }

    &-item-ico {
      width: 18px;
      margin: 0px 4px;
    }
  }

  &__row {
    border-bottom: solid 1px #374b62;
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.15;
    letter-spacing: 0.4px;
    color: #ffffff;
    text-transform: uppercase;
    text-align: left;
    cursor: pointer;
    max-height: 28px;

    &:hover {
      background-color: #506b89;

      i {
        color: #cae9ff;
      }
    }

    &-item {
    }

    &-item-number {
      padding-left: 12px;
      width: 46px;
    }

    &-item-instrument {
      width: 73px;
      margin: 0px 4px;
    }

    &-item-time {
      width: 142px;
      margin: 0px 4px;
    }

    &-item-type {
      width: 40px;
      margin: 0px 4px;
    }

    &-item-volume {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-price {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-tp {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-sl {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-s {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-per {
      width: 35px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-pip {
      width: 35px;
      text-align: right;
      padding-right: 12px;
    }

    &-item-ico {
      display: flex;
      width: 24px;
      justify-content: center;

      &-info {
        i {
          font-size: 14px !important;
        }
      }

      i {
        font-size: 16px;
        line-height: 1;
        color: #718da8;

        &:hover {
          color: #cae9ff;
        }
      }

      &:last-child {
        margin-right: 8px;
      }
    }
  }
}
@media screen and (max-width:1440px) {
    td.open-positions__title-row-item-pl-pip {
        display: none;
    }
    td.open-positions__row-item-pl-pip {
        display: none;
    }
    td.open-positions__title-row-item-pl-s {
        display: none;
    }
    td.open-positions__row-item-pl-s {
        display: none;
    }
    .open-positions__title-row-item-tp {
        text-align: center;
    }
    .open-positions__row-item-sl {
        text-align: center;
    }
}
</style>